// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupListItem__group-container-b4c6e5 {
  background-color: var(--group-list-item-background);
  display: flex;
  padding: 8px 16px;
  box-sizing: border-box;
  cursor: pointer;
  text-decoration: none;
  --group-list-item-background: var(--base-0);
}

.GroupListItem__group-container-b4c6e5:hover {
  --group-list-item-background: var(--base-17);
}

.GroupListItem__group-container-b4c6e5.GroupListItem__focus-cf2ef4 {
  --group-list-item-background: var(--base-17);
}

.GroupListItem__group-container-b4c6e5.GroupListItem__active-ba1151 {
  --group-list-item-background: var(--base-20);
}

.GroupListItem__context-icon-fe7557 {
  fill: var(--base-80);
}

.GroupListItem__avatar-ad7df3 {
  position: relative;
}

.GroupListItem__space-avatar-f19e22 {
  background-color: var(--group-list-item-background);
  border-radius: 8px;
  padding: 2px;
  position: absolute;
  right: -4px;
  bottom: -4px;
}

.GroupListItem__content-ee7905 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  margin-inline-start: 12px;
  overflow: hidden;
}

.GroupListItem__header-aef6bc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
}

.GroupListItem__title-wrapper-fe551a {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  overflow: hidden;
}

.GroupListItem__title-bd6766 {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--base-110);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.GroupListItem__icon-af6924 {
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
}

.GroupListItem__icon-bot-d28e1f {
  margin-inline-start: 4px;
  fill: var(--brand-secondary-30);
}

.GroupListItem__icon-muted-b8d87c {
  fill: var(--base-60);
}

.GroupListItem__date-eecedc {
  margin-inline-start: 4px;
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle);
  color: var(--base-80);
  white-space: nowrap;
}

.GroupListItem__footer-f6a09c {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 24px;
}

.GroupListItem__description-c9b044 {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  min-width: 0;
  color: var(--base-80);
}

.GroupListItem__icon-panel-c66e16 {
  align-items: center;
  display: flex;
  justify-items: end;
  gap: 8px;
  margin-inline-start: 4px;
}

.GroupListItem__badge-e5b34c {
  margin-inline-start: 4px;
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/components/GroupListItem/GroupListItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,mDAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EAEA,2CAAA;AAAF;;AAGA;EACE,4CAAA;AAAF;;AAGA;EACE,4CAAA;AAAF;;AAGA;EACE,4CAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,mDAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,OAAA;EACA,gBAAA;AAAF;;AAGA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,wBAAA;EACA,+BAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,wBAAA;EACA,4BAAA;EACA,4CAAA;EACA,qBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AAAF;;AAGA;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,wBAAA;AAAF;;AAGA;EACE,wBAAA;AAAF","sourcesContent":[".group-container {\n  background-color: var(--group-list-item-background);\n  display: flex;\n  padding: 8px 16px;\n  box-sizing: border-box;\n  cursor: pointer;\n  text-decoration: none;\n\n  --group-list-item-background: var(--base-0);\n}\n\n.group-container:hover {\n  --group-list-item-background: var(--base-17);\n}\n\n.group-container.focus {\n  --group-list-item-background: var(--base-17);\n}\n\n.group-container.active {\n  --group-list-item-background: var(--base-20);\n}\n\n.context-icon {\n  fill: var(--base-80);\n}\n\n.avatar {\n  position: relative;\n}\n\n.space-avatar {\n  background-color: var(--group-list-item-background);\n  border-radius: 8px;\n  padding: 2px;\n  position: absolute;\n  right: -4px;\n  bottom: -4px;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  flex-grow: 1;\n  margin-inline-start: 12px;\n  overflow: hidden;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  overflow: hidden;\n}\n\n.title-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 1;\n  overflow: hidden;\n}\n\n.title {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--base-110);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.icon {\n  flex: 0 0 auto;\n  width: 24px;\n  height: 24px;\n}\n\n.icon-bot {\n  margin-inline-start: 4px;\n  fill: var(--brand-secondary-30);\n}\n\n.icon-muted {\n  fill: var(--base-60);\n}\n\n.date {\n  margin-inline-start: 4px;\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle);\n  color: var(--base-80);\n  white-space: nowrap;\n}\n\n.footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 24px;\n}\n\n.description {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  min-width: 0;\n  color: var(--base-80);\n}\n\n.icon-panel {\n  align-items: center;\n  display: flex;\n  justify-items: end;\n  gap: 8px;\n  margin-inline-start: 4px;\n}\n\n.badge {\n  margin-inline-start: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"group-container": `GroupListItem__group-container-b4c6e5`,
	"groupContainer": `GroupListItem__group-container-b4c6e5`,
	"focus": `GroupListItem__focus-cf2ef4`,
	"active": `GroupListItem__active-ba1151`,
	"context-icon": `GroupListItem__context-icon-fe7557`,
	"contextIcon": `GroupListItem__context-icon-fe7557`,
	"avatar": `GroupListItem__avatar-ad7df3`,
	"space-avatar": `GroupListItem__space-avatar-f19e22`,
	"spaceAvatar": `GroupListItem__space-avatar-f19e22`,
	"content": `GroupListItem__content-ee7905`,
	"header": `GroupListItem__header-aef6bc`,
	"title-wrapper": `GroupListItem__title-wrapper-fe551a`,
	"titleWrapper": `GroupListItem__title-wrapper-fe551a`,
	"title": `GroupListItem__title-bd6766`,
	"icon": `GroupListItem__icon-af6924`,
	"icon-bot": `GroupListItem__icon-bot-d28e1f`,
	"iconBot": `GroupListItem__icon-bot-d28e1f`,
	"icon-muted": `GroupListItem__icon-muted-b8d87c`,
	"iconMuted": `GroupListItem__icon-muted-b8d87c`,
	"date": `GroupListItem__date-eecedc`,
	"footer": `GroupListItem__footer-f6a09c`,
	"description": `GroupListItem__description-c9b044`,
	"icon-panel": `GroupListItem__icon-panel-c66e16`,
	"iconPanel": `GroupListItem__icon-panel-c66e16`,
	"badge": `GroupListItem__badge-e5b34c`
};
module.exports = ___CSS_LOADER_EXPORT___;
